import './index.css'

const NotFound = () => (
    <div className='notFound'>
        <h1 className='notFoundHeading'>Page Not Found !</h1>
    </div>
)

export default NotFound